module.exports = __webpack_public_path__ + "img/jesse.64a90378.jpg";